import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// let introImgs = '.horizontal-scroll__img'
// let toLeft = '.horizontal-scroll__toLeft'
// let toRight = '.horizontal-scroll__toRight'



// // gsap.to(introImgs, {
// // 	xPercent: 50,
// // 	ease: "none",
// // 	ScrollTrigger: {
// // 		trigger: introImgs,
// // 		scrub: true,
// // 		// start:
// // 	}
// // })



// gsap.utils.toArray(toLeft).forEach((imgLeft) => {

// 	gsap.from(imgLeft, {
// 		x: -250,
// 		ease: "none",
// 		scrollTrigger: {
// 			trigger: '.horizontal-scroll__container',
// 			scrub: true,
// 			markers:true,
// 			// pin: true,
// 			// start: "=-100",
// 			end: "=+3000",
// 			containerAnimation: scrollTween,
//     		start: "left center",
//    			toggleActions: "play none none reset"
// 		},
// 	})

// })

// gsap.utils.toArray(toRight).forEach((imgRight) => {

// 	gsap.from(imgRight, {
// 		x: 250,
// 		ease: "none",
// 		scrollTrigger: {
// 			trigger: '.horizontal-scroll__container',
// 			scrub: true,
// 			// start: "=-100",
// 			end: "=+3000",
// 		},
// 	})

// })


// let scrollTween = gsap.to(sections, {
//     xPercent: -100 * (sections.length - 1),
//     ease: "none", // <-- IMPORTANT!
//     scrollTrigger: {
//       trigger: ".container",
//       pin: true,
//       scrub: 0.1,
//       //snap: directionalSnap(1 / (sections.length - 1)),
//       end: "+=3000"
//     }
//   });